module.exports = __webpack_public_path__ + "img/periodic_overspeed.7adeb01c.png";